import { AppBar, Avatar, Button, Container, Divider, Grid, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from "@mui/material";
import { useState } from "react";
import isNarrow from "../functions/isNarrow";
import GetAvatarColour from "../functions/GetAvatarColour";
import { logout } from "../firebase/firebase_setup";
import { AdminPanelSettings, Apps, CorporateFare, Dashboard, Logout, ManageAccounts, SwitchAccount } from "@mui/icons-material";
import '../CSS/private/AppBarTemplate.css';
import { useLocation, useNavigate } from "react-router-dom";

function AppBarTemplate(props) {

  const navigate = useNavigate();
  const location = useLocation();
  const pathRoot = location.pathname.split('/')[1];

  const [narrow, setNarrow] = useState(isNarrow(document.clientWidth));
  window.addEventListener("resize", function(event) {
    setNarrow(isNarrow(document.body.clientWidth));
  })

  let admin = false;
  props.userData?.organisations?.forEach((org) => {
    if(org.id === props.userData.active_organisation_id && (org.admin || org.owner)) admin = true;
  })

  return (
    <AppBar position="fixed" justify="space-between" sx={{ bgcolor: "#151515", height: "70px", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Container maxWidth="xl">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item display="flex" alignItems="center">
            <img style={{...{marginTop: '5px'},...{marginRight: '5px'}}} src={props.logo} alt='logo' height='60px' />
            {narrow? null : (
              <div>
                <span className='slp-appbartemplate-title sl-prevent-selection'>{props.title}</span>
                <span className='slp-appbartemplate-subtitle sl-prevent-selection'>{props.subtitle}</span>
              </div>
            )}
          </Grid>
          <Grid item>
            {
              props.userData !== undefined? 
                <UserOptions userData={props.userData} isAdmin={admin} pathRoot={pathRoot} projectData={props.projectData} setOrganisationDialogOpen={props.setOrganisationDialogOpen} setProjectDialogOpen={props.setProjectDialogOpen} setSettingsOpen={props.setSettingsOpen} navigate={navigate} />
              :
                <Button 
                  variant='outlined' 
                  sx={{marginTop: '5px'}}
                  onClick={() => {
                    window.location.replace('/login')
                  }}
                >Sign In</Button>
            }
          </Grid>
        </Grid>
      </Container>
    </AppBar>
  )
}

export default AppBarTemplate;


function UserOptions({userData, projectData, setOrganisationDialogOpen, setProjectDialogOpen, setSettingsOpen, isAdmin, navigate, pathRoot}) {

  const [anchorElement, setAnchorElement] = useState(null);
  const open = Boolean(anchorElement);
  const handleClick = (event) => {
    setAnchorElement(event.currentTarget);
  }
  const handleClose = () => {
    setAnchorElement(null);
  }
  
  return (
    <div style={{...{display: 'flex'},...{alignItems: 'center'}}}>
      <div style={{textAlign: 'end'}}>
          Hello, {userData.name}<br/>
          <small style={{opacity: '0.2'}}><i>
            {userData.active_organisation_id} {projectData !== false && projectData.constructor !== Array? ('/ ' + projectData.uid) : ''}
          </i></small>
      </div>
      <Tooltip title={userData.email}>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'profile-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar sx={{ bgcolor: GetAvatarColour(userData.name)}}>{userData.name.toUpperCase().charAt(0)}</Avatar>
        </IconButton>
      </Tooltip>

      <Menu 
        anchorEl={anchorElement}
        id='profile-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        paperProps={paperProps}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => setSettingsOpen(true)}>
          <ListItemIcon>
            <ManageAccounts color={"primary"} fontSize="small" />
          </ListItemIcon>
          My Account
        </MenuItem>
        <MenuItem onClick={() => {setOrganisationDialogOpen(true)}}>
          <ListItemIcon>
            <CorporateFare color={"primary"} fontSize="small" />
          </ListItemIcon>
          Change Organisation
        </MenuItem>
        {
          pathRoot === 'console' &&
          <MenuItem onClick={() => {setProjectDialogOpen(true)}}>
            <ListItemIcon>
              <SwitchAccount color={"primary"} fontSize="small" />
            </ListItemIcon>
            Change Project
          </MenuItem>
        }
        <Divider sx={{width: '100%'}} />
        {
          isAdmin && 
          <>
            <MenuItem onClick={() => {
                if(pathRoot === 'console') navigate('/admin-console');
                else navigate('/console');
              }}>
              <ListItemIcon>
                <Dashboard color={"primary"} fontSize="small" />
              </ListItemIcon>
              {
                pathRoot === 'console'
                ? 'Admin Console'
                : 'Project Console'
              }
            </MenuItem>
            <Divider sx={{width: '100%'}} />
          </>
        }
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout color={"primary"} fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  )
}

const paperProps = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
}

/*
<MenuItem onClick={() => {window.location = "https://shoru.app/console"}}>
  <ListItemIcon>
    <Apps color={"primary"} fontSize="small" />
  </ListItemIcon>
  Go to Shoru
</MenuItem>
<MenuItem onClick={() => {window.location = "https://account.shoru.app"}}>
  <ListItemIcon>
    <ManageAccounts color={"primary"} fontSize="small" />
  </ListItemIcon>
  My Account
</MenuItem>
<Divider sx={{width: '100%'}} />
*/